import api from './axiosConfig';
import  * as home from './modules/home';
import  * as event from './modules/event';
import * as news from './modules/news';
import * as result from './modules/result';
import * as user from './modules/user';
// 导入其他模块

const  apiService =  {
  ...api,
home,
 event,
  news,
  result,
  user
};


export default apiService
